import OnSelectionModal from './OnSelectionModal';

export default OnSelectionModal;
